const RA_COLUMNS = Array.from({ length: 67 }, (_, i) => {
  const n = String(i + 1).padStart(2, '0')
  return `RA${n}`
})

const TEMPLATE_HEADERS = [
  'State',
  'plan_year',
  'Hios Plan ID',
  'Carrier',
  'Plan Name',
  'Household Name',
  'plan_type',
  'level',
  'HSA',
  'Network_Name',
  'On EXchange',
  'Off EXchange',
  'is_for_sale',
  'ProofOfResidenceRequired',
  'service_area_id',
  'BaseRate',
  'PlanFee',
  'Plan Status',
  'Crosswalk Plan ID',
  ...RA_COLUMNS,
]

export function downloadPlanAndRateTemplate(): void {
  const csv = TEMPLATE_HEADERS.join(',')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'plan-and-rate-override-template.csv'
  link.click()
  URL.revokeObjectURL(url)
}
